import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from '@angular/router';
import { QuizService } from 'src/app/services/quiz.service';
import { MatSnackBar, MatDialog, MatStepper } from '@angular/material';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { LearnerService } from 'src/app/services/learner.service';
import { Observable } from 'rxjs';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { QuizListModalComponent } from '../quiz-list-modal/quiz-list-modal.component';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component';
import { TimeSheetService } from '../../services/time-sheet.service';
import { UserRoleService } from 'src/app/services/user-role.service';
import { JobService } from 'src/app/services//jobs/job.service';
import { FileService } from '../../services/file.service';

@Component({
  selector: 'app-appear-quiz',
  templateUrl: './appear-quiz.component.html',
  styleUrls: ['./appear-quiz.component.scss']
})
export class AppearQuizComponent implements OnInit {

  // keepSideNavOpen = true;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;

  isAssessment = true;
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  learnerSign: any;
  trainerSign: any;
  iqaSign: any;
  learnerSignError: boolean = false;
  trainerSignError: boolean = false;
  iqaSignError: boolean = false;
  evidences;
  units = ['001', '003', '004', '005', '006', '007', '008', '009', '011', '012', '016', '018']
  answerArray = [];
  disableQuiz: boolean;
  questionsAnswer: any = null;
  questions: any = null;
  shuffledArray: any;
  disable = false
  quizId: any;
  learnerId: any;
  quizDetails: any;
  noDataMsg: any;
  loading: boolean;
  detailsForm: FormGroup;
  unitsValue: any;
  evidenceValue: any;
  isDate: boolean;
  currentUser: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  isUnit: boolean;
  criteriaEvidence: any;
  user;
  assessment = {
    marks: '',
    remarks: '',
    status: 'Pending'
  };
  isEdit: boolean = false;
  submittedAnswerId: any;
  learnerStatus: string;
  files;
  showModal: boolean;
  selectedIndex: any;
  ansIndex: any;
  selectedQuesIndex: any;
  buttonLoaderSubmit: boolean = false
  garbageSignatures = [];
  date: any;
  deletedImages = [];
  selectedAnsIndex: any;
  assignStatus: any = null
  displayDate = new Date();
  name;
  hideSubmitBtn: boolean;
  isTrainerQuiz: boolean = false;
  displayError = false
  alphabet = []
  uniqQuestion = []
  jobId
  displayTotal: any = 0;
  totalQuestionsList = []
  selectedTabIndex
  systemDate: any;
  isNotDisplay: boolean = false;
  userRole: any;


  constructor(
    public formBuilder: FormBuilder,
    public _learnerService: LearnerService,
    public dialog: MatDialog,
    public cd: ChangeDetectorRef,
    public activatedRoute: ActivatedRoute,
    public _quizService: QuizService,
    public router: Router,
    public _snackBar: MatSnackBar,
    public _timeSheetService: TimeSheetService,
    public _jobService: JobService,
    public _userRoleService: UserRoleService,
    public _fileService: FileService
  ) {

    this.activatedRoute.queryParams.subscribe(qparam => {
      console.log("param ?????? ", qparam);
      if (qparam.userRole) {
        this.userRole = qparam.userRole
        this.getUserRole()
      }
    })

  }

  ngOnInit() {
    this.loading = true
    console.log('this.router.url', this.router.url)
    this.activatedRoute.queryParams.subscribe(qparam => {
      console.log("what is params details==========", qparam);

      this.quizId = qparam.quizId
      this.learnerId = qparam.learnerId
      this.jobId = qparam.jobId
      console.log("jobid.............", this.jobId);

      this.getQuestions()
      this.getEvidenceList()
      this.createForm()


      if (qparam.userRole) {
        let getRole = qparam.userRole
        if (getRole == 0) this.isAdmin = true
        else if (getRole == 1) this.isTrainer = true
        else if (getRole == 2) this.isIQA = true
        else if (getRole == 3) this.isLearner = true
      }
      // this.getJobId()

    })


    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log("this user in appear quiz ===>", this.user, this.currentUser);
    if (this.user.isLearner) {
      this.name = this.currentUser.name
    }
    /*Disable quiz as per user role*/
    console.log("hello current user find ===>", this.user)
    this.disableQuiz = this.user.isTrainer ? true : false;
    this.disable = this.user.isTrainer ? true : false
    this.hideSubmitBtn = this.user.isTrainer ? true : false;
    console.log("this.disableQuiz ====>", this.disableQuiz);
    console.log("QUIZ ID IN APPEAR QUIZ", this.quizId)
    if (this.quizId == '5f49136d878ce75479694961') {
      this.disableQuiz = this.user.isLearner ? true : false;
      this.hideSubmitBtn = false;
    }
  }
  // getJobId() {
  //   this._jobService.getJobById(this.jobId).subscribe((job) => {
  //     console.log("job.......",job);

  //     this.createForm()
  //     let getRole = this._userRoleService.getUserRole(job.data[0].instructors,'job');
  //     if (getRole.isAdmin) this.isAdmin = true
  //     else if (getRole.isLearner) this.isLearner = true
  //     else if (getRole.isTrainer) this.isTrainer = true
  //     else if (getRole.isIQA) this.isIQA = true

  //   })
  // }


  show(i, quesIndex, type) {
    console.log(i, quesIndex, type)
    if (type == 'questionIndex') {
      this.selectedIndex = i
      this.selectedQuesIndex = quesIndex
    }
    else {
      this.selectedAnsIndex = quesIndex;
      this.ansIndex = i
    }
    // this.showModal = true; // Show-Hide Modal Check


  }
  //Bootstrap Modal Close event
  hide(type) {
    // this.showModal = false;
    if (type == 'questionIndex') {
      this.selectedIndex = -1
    }
    else {
      this.ansIndex = -1
    }
  }


  getUserRole() {
    console.log("what is the user role value", this.userRole);

    // this.getRole = this._userRoleService.getUserRole(this.job.instructors, 'job');
    // console.log("this.getRole ?? ", this.getRole);
    if (this.userRole == 0) this.isAdmin = true
    else if (this.userRole == 1) this.isTrainer = true
    else if (this.userRole == 2) this.isIQA = true
    else if (this.userRole == 3) this.isLearner = true
    // else if (this.userRole == 4) this.isClient = true
  }


  createForm() {
    this.detailsForm = this.formBuilder.group({
      date: new FormControl(''),
      // evidence: new FormControl(''),
      units: new FormControl('')
    })
  }

  onChangeEvent(event) {
    this.detailsForm.patchValue({ date: event })
    console.log("event", event);
  }

  // questionId & answer & quizId

  answerChanged(event, ques, ansIndex) {
    console.log("when ans is submit============", ques, ansIndex)
    console.log("what is event value", this.answerArray);
    let obj1 = {
      questionId: ques._id
    }

    let questionIndex = _.findIndex(this.uniqQuestion, function (o) { return (o.questionId == ques._id) });
    console.log("==============,", questionIndex);
    if (questionIndex == -1) {
      this.uniqQuestion.push(obj1)
    }
    console.log("what is final array of questions", this.uniqQuestion);

    ques['answer'] = event.value ? event.value : event.target.value
    let tempAns = event.value ? event.value : event.target.value
    let obj = {
      questionId: ques._id,
      answer: tempAns,
      ansIndex: ansIndex,
      quizId: this.quizId,
      learnerId: this.learnerId,
      answerId: (ques.answers && ques.answers.length) ? (ques.answers[ansIndex] && ques.answers[ansIndex].answerId) ? ques.answers[ansIndex].answerId : '' : '',
      files: (ques.answers && ques.answers.length) ? ques.answers[0].files : [],
      deleteImage: (ques.answers && ques.answers.length) ? ques.answers[0].deleteImage : []
    }
    if (ques.type == "Text") {
      ques.answers[ansIndex].answerSubmitted = event.target.value
    }



    // if (ques.answerId) {
    //   obj['answerId'] = ques.answerId
    // }
    // if (ques.answers && ques.answers.length > 0) {
    //   obj['answerId'] = ques.answers[0].answerId
    // }
    if (this.answerArray.length) {

      let index = _.findIndex(this.answerArray, function (o) { return (o.questionId == ques._id && o.ansIndex == ansIndex) });
      console.log("index ====>", index)
      if (index <= -1) {
        // this.answerArray.push(obj)
        if (ques.questionType == 'Text' && event.target.value.length > 0) {
          this.answerArray.push(obj)
        }
        if (ques.questionType != 'Text') {
          console.log("call this first else");
          this.answerArray.push(obj)
        }
      }
      else {
        obj.files = this.answerArray[index].files
        obj.answerId = this.answerArray[index].answerId
        if (ques.questionType == 'Text' && event.target.value.length > 0) {
          this.answerArray[index] = obj;
        }
        if (ques.questionType == 'Text') {

          if (obj && obj.answerId != "") {
            console.log("check for final obj to send", obj);
            this.answerArray[index] = obj;
          } else {
            console.log("with answer id but blank ans");
            this.answerArray.splice(index, 1)

          }
        }
        if (ques.questionType != 'Text') {
          console.log("call this second else", obj, index);
          //       obj.files = this.answerArray[index].files
          // obj.answerId = this.answerArray[index].answerId
          this.answerArray[index] = obj;
        }

        // this.answerArray[index] = obj;
        // console.log(this.answerArray);
      }
    }
    else {
      if (ques.questionType == 'Text' && event.target.value.length > 0) {
        this.answerArray.push(obj)
      }
      if (ques.questionType != 'Text') {
        console.log("call this third else", ques);
        this.answerArray.push(obj)
      }
      // this.answerArray.push(obj)
    }
    console.log("this is the final ans array to be send", this.answerArray, obj);

  }


  // answerChanged(event, ques, ansIndex) {
  //   // console.log("when ans is submit============", event)
  //   // console.log("what is event value", event.target.value.length);
  //   let obj1 = {
  //     questionId: ques._id
  //   }

  //   let questionIndex = _.findIndex(this.uniqQuestion, function (o) { return (o.questionId == ques._id) });
  //   console.log("==============,", questionIndex);
  //   if (questionIndex == -1) {
  //     this.uniqQuestion.push(obj1)
  //   }
  //   console.log("what is final array of questions", this.uniqQuestion);

  //   ques['answer'] = event.value ? event.value : event.target.value
  //   let tempAns = event.value ? event.value : event.target.value
  //   let obj = {
  //     questionId: ques._id,
  //     answer: tempAns,
  //     ansIndex: ansIndex,
  //     quizId: this.quizId,
  //     learnerId: this.learnerId,
  //     answerId: (ques.answers && ques.answers.length) ? (ques.answers[ansIndex] && ques.answers[ansIndex].answerId) ? ques.answers[ansIndex].answerId : '' : '',
  //     files: (ques.answers && ques.answers.length) ? ques.answers[0].files : [],
  //     deleteImage: (ques.answers && ques.answers.length) ? ques.answers[0].deleteImage : []
  //   }
  //   if (ques.type == "Text") {
  //     ques.answers[ansIndex].answerSubmitted = event.target.value
  //   }



  //   // if (ques.answerId) {
  //   //   obj['answerId'] = ques.answerId
  //   // }
  //   // if (ques.answers && ques.answers.length > 0) {
  //   //   obj['answerId'] = ques.answers[0].answerId
  //   // }
  //   if (this.answerArray.length) {

  //     let index = _.findIndex(this.answerArray, function (o) { return (o.questionId == ques._id && o.ansIndex == ansIndex) });
  //     console.log("index ====>", index)
  //     if (index <= -1) {
  //       if (ques.questionType == 'Text' && event.target.value.length > 0) {

  //         this.answerArray.push(obj)
  //       }
  //       if (ques.questionType != 'Text') {
  //         console.log("call this first else");

  //         this.answerArray.push(obj)
  //       }
  //     }
  //     else {
  //       obj.files = this.answerArray[index].files
  //       if (ques.questionType == 'Text' && event.target.value.length > 0) {

  //         this.answerArray[index] = obj;
  //       } else {
  //         this.answerArray.splice(index, 1)
  //       }
  //       if (ques.questionType != 'Text') {
  //         console.log("call this second else", obj, index);
  //         //       obj.files = this.answerArray[index].files
  //         obj.answerId = this.answerArray[index].answerId
  //         this.answerArray[index] = obj;
  //       }
  //       console.log(this.answerArray);
  //     }
  //   }
  //   else {
  //     if (ques.questionType == 'Text' && event.target.value.length > 0) {
  //       this.answerArray.push(obj)
  //     }
  //     if (ques.questionType != 'Text') {
  //       console.log("call this third else", ques);
  //       this.answerArray.push(obj)
  //     }

  //   }
  //   console.log("this is the final ans array to be send", this.answerArray);

  // }




  drop(event: CdkDragDrop<string[]>, singleQuestion) {
    console.log("singleQuestion.options before swap", singleQuestion);
    let obj1 = {
      questionId: singleQuestion._id
    }

    let questionIndex = _.findIndex(this.uniqQuestion, function (o) { return (o.questionId == singleQuestion._id) });
    console.log("==============,", questionIndex);
    if (questionIndex == -1) {
      this.uniqQuestion.push(obj1)
    }



    singleQuestion['answer'] = "true"
    let beforeswapIndex = []
    if (this.isEdit) {
      if (singleQuestion.answers[0].answerSubmitted && singleQuestion.answers[0].answerSubmitted.length) {
        singleQuestion.answers[0].answerSubmitted.forEach(el => {
          beforeswapIndex.push(singleQuestion.options.indexOf(el))
        });
      } else {
        singleQuestion.options.forEach(el => {
          beforeswapIndex.push(singleQuestion.options.indexOf(el))
        })
      }
    }
    else {
      singleQuestion.options.forEach(el => {
        beforeswapIndex.push(singleQuestion.options.indexOf(el))
      })
    }
    console.log("%cTEMPANS", "color:red", beforeswapIndex);
    if (this.isEdit) {

      if (singleQuestion.answers[0].answerSubmitted && singleQuestion.answers[0].answerSubmitted.length) {
        moveItemInArray(singleQuestion.answers[0].answerSubmitted, event.previousIndex, event.currentIndex);
      } else {
        moveItemInArray(singleQuestion.options, event.previousIndex, event.currentIndex);
      }
    }
    else {
      moveItemInArray(singleQuestion.options, event.previousIndex, event.currentIndex);

    }
    moveItemInArray(beforeswapIndex, event.previousIndex, event.currentIndex);
    console.log("event", event);
    console.log("beforeswapIndex", beforeswapIndex);
    console.log("singleQuestion.options after swap", singleQuestion.options);
    // this.answerArray = singleQuestion.options
    let tempAns: any;
    if (this.isEdit) {

      if (singleQuestion.answers[0].answerSubmitted && singleQuestion.answers[0].answerSubmitted.length) {
        tempAns = singleQuestion.answers[0].answerSubmitted
      } else {
        tempAns = singleQuestion.options
      }
    }
    else {
      tempAns = singleQuestion.options

    }
    // let obj = {
    //   questionId: ques._id,
    //   answer: tempAns,
    //   ansIndex: ansIndex,
    //   quizId: this.quizId,
    //   learnerId: this.learnerId,
    //   answerId: ques.answers[0].answerId,
    //   files: ques.answers[0].files
    // }
    let obj = {
      questionId: singleQuestion._id,
      answer: tempAns,
      quizId: this.quizId,
      learnerId: this.learnerId,
      answerId: singleQuestion.answers[0].answerId,
      files: singleQuestion.answers[0].files,
      deleteImage: singleQuestion.answers[0].deleteImage
    }

    if (this.answerArray.length) {
      let index = _.findIndex(this.answerArray, function (o) { return o.questionId == singleQuestion._id })
      if (index > -1) {
        this.answerArray[index] = obj
      }
      else {
        this.answerArray.push(obj)
      }
    }
    else {
      this.answerArray.push(obj)
    }
    console.log("array index ====<", this.answerArray);
    console.log("singleQuestion.virtualCorrectAnswer", singleQuestion.virtualCorrectAnswer);


    // // let t = this.cardArrayCopy.every((value, index) => value === this.cardArray[index])
    // let temp = this.answer
    // let t = this.cardArrayCopy.every(function (value, index) {
    //   console.log('value', value, 'this.cardArray[index]', temp[index])
    //   return value === temp[index]
    // })
    // if (t) {
    //   this.disable = true
    // }

    // console.log('t', t);
    // console.log('event', event.previousContainer.data, event.container.data)
    // console.log('this.cardArrayCopy', this.cardArrayCopy, 'this.cardArray', this.answer)
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      width: '50%'
    });
    return dialogRef.afterClosed();
  }
  openImage(path) {
    let link = path
    console.log("what is the link", link);
    window.open(link, "_blank");
  }

  submit() {
    console.log('/learner/view/' + this.learnerId, { queryParams: { job: this.jobId } })
    this.buttonLoaderSubmit = true;
    // this._timeSheetService.getSystemDate().subscribe((date) => {
    // this.systemDate = date.systemDate
    if (this.currentUser.userRole[0] == 'learner' && !this.learnerSign) {
      !this.learnerSign ? this.learnerSignError = true : this.learnerSignError = false;
      this.buttonLoaderSubmit = false;
    }
    else if (this.uniqQuestion.length != this.totalQuestionsList.length) {
      console.log("what is answer array length", this.uniqQuestion);
      console.log("what is the value of total question array", this.totalQuestionsList);


      this.displayError = true
      this.buttonLoaderSubmit = false;
    }
    /*else if(this.currentUser.userRole[0] == 'admin' && !this.iqaSign){
      !this.learnerSign ? this.learnerSignError = true : this.learnerSignError = false;
      !this.iqaSign ? this.iqaSignError  =true : this.iqaSignError = false;
      !this.trainerSign ? this.trainerSignError = true : this.trainerSignError = false; 
    }*/
    else {
      this.displayError = false
      console.log("this.answerArray.length", this.answerArray.length, "this.questions.length", this.questions.length)
      if (this.answerArray.length == this.questions.length) {
        console.log("ALL ANSWERSSSS FILLED")
      } else {
        console.log("NOT SAME LENGTH SOMETHING MISSING")
      }


      console.log('THE ANSWER ARRAY IS', this.answerArray);
      let assementArray = []
      console.log("quiz details in submit function ======> ", this.quizDetails);
      let obj = {
        details: this.detailsForm.value,
        assessment: this.assessment,
        criteriaEvidence: this.criteriaEvidence,
        answers: this.answerArray,
        iqaSign: this.iqaSign,
        quizId: this.quizId,
        learnerId: this.learnerId,
        jobId: this.jobId,
        garbageSignatures: this.garbageSignatures,
        deletedImages: this.deletedImages,
        hbsPath: this.quizDetails.hbsPath
      }
      if (this.trainerSign) {
        obj['trainerSign'] = this.trainerSign;
      }
      if (this.learnerSign) {
        obj["learnerSign"] = this.learnerSign;
      }
      // if (this.assessment.status == 'Pending' || this.assessment.status == 'Saved') {
      if (this.assessment.status == 'Pending') {
        obj.assessment.status = 'Submitted'
      } else if (this.assessment.status == 'Requested for Resubmission') {
        obj.assessment.status = 'Re-Submitted'
      }
      if (!this.isEdit) {
        obj.assessment['createdDate'] = this.systemDate

        assementArray.push(obj.assessment)
        obj['assessmentList'] = assementArray
        console.log("DATA TO SEND ON SERVER", obj)
        this.answerArray.forEach((ans) => {
          this.displayTotal = Number(this.displayTotal) + Number(ans.answer)
        })
        obj.assessment['marks'] = this.displayTotal
        console.log("this is the final total of score", this.displayTotal);

        this._quizService.addLearnerAns(obj).subscribe(res => {
          this.buttonLoaderSubmit = false;
          if (res && res.data && res.data.finalMarks || res.data.finalMarks === 0) {
            console.log("res", res)
            let data = {
              title: 'Marks',
              marks: res.data.finalMarks + '/' + res.data.totalMarks,
              src: 'https://platinum-rail-services-client.s3.eu-west-2.amazonaws.com/assets/paper.gif',
              // finalMarks: res.data.finalMarks,
              // totalMarks: res.data.totalMarks,
              minMarks: res.data.minMarks,
            }
            if (res.msg == "Sorry please try again") {
              data['content'] = 'Please re-appear the quiz.'
              this.openDialog(QuizListModalComponent, data).subscribe(dialogRes => {
                console.log("modal closed")
                if (dialogRes == undefined) {
                  return dialogRes
                }
              })
            }
            else {
              if (this.quizDetails.calcScore == true) {
                console.log("this.quizDetails.calcScore", this.quizDetails.calcScore, res)
                data['content'] = 'Congratulations!'
                data['src'] = 'https://platinum-rail-services-client.s3.eu-west-2.amazonaws.com/assets/paper.gif'

                // this.answerArray.forEach((ans) => {
                //   this.displayTotal = Number(this.displayTotal) + Number(ans.answer)
                // })

                data['marks'] = String(this.displayTotal)
                console.log("this.displayTotal", this.displayTotal)
                this.openDialog(QuizListModalComponent, data).subscribe(dialogRes => {
                  console.log("modal closed")
                  if (dialogRes == undefined) {
                    this.openSnackBar("Submission Successfull", "OK")
                    this.router.navigate(['/learner/view/' + this.learnerId], { queryParams: { job: this.jobId } })
                  } else {
                    if (this.user && this.user.isLearner) {
                      this.hideSubmitBtn = true
                    }
                    console.log("this is for display new tab", this.stepper._steps.length);
                    if (this.stepper && this.stepper._steps.length == 4) {
                      this.selectedTabIndex = 3
                    } else {
                      this.selectedTabIndex = 2
                    }
                  }
                  this.openSnackBar("Submission Successfull", "OK")
                  // this.router.navigate(['/user/' + this.learnerId], { queryParams: { job: this.jobId } })
                })
              } else {
                this.openSnackBar("Submission Successfull", "OK")
                this.router.navigate(['/learner/view/' + this.learnerId], { queryParams: { job: this.jobId } })
              }
            }
          } else {
            this.openSnackBar("Submission Successfull", "OK")
            this.router.navigate(['/learner/view/' + this.learnerId], { queryParams: { job: this.jobId } })
          }
        }, error => {
          console.log("ERROR WHILE SUBMIT ANS", error)
          this.buttonLoaderSubmit = false
        })
      } else {
        obj.assessment['createdDate'] = this.systemDate
        this.answerArray.forEach((ans) => {
          this.displayTotal = Number(this.displayTotal) + Number(ans.answer)
        })
        obj.assessment['marks'] = this.displayTotal
        assementArray.push(obj.assessment)
        obj['assessmentList'] = assementArray
        obj['submittedAnswerId'] = this.submittedAnswerId;

        this._quizService.editLearnerAns(obj).subscribe(res => {
          console.log("WHAT IS THE RESPONSE,", res)
          this.buttonLoaderSubmit = false;
          let data = {
            title: 'Marks',
            marks: res.data.finalMarks + '/' + res.data.totalMarks,
            src: 'https://platinum-rail-services-client.s3.eu-west-2.amazonaws.com/assets/paper.gif',
            // finalMarks: res.data.finalMarks,
            // totalMarks: res.data.totalMarks,
            minMarks: res.data.minMarks
          }
          if (res.msg === "Sorry please try again") {
            data['content'] = 'Please re-appear the quiz.'
            this.openDialog(QuizListModalComponent, data).subscribe(dialogRes => {
              console.log("modal closed", dialogRes)
              if (dialogRes == undefined) {
                return dialogRes
              }
            })
          } else {
            if (this.quizDetails.calcScore == true) {
              data['content'] = 'Congratulations!'
              data['src'] = 'https://platinum-rail-services-client.s3.eu-west-2.amazonaws.com/assets/paper.gif'
              // this.answerArray.forEach((ans) => {
              //   this.displayTotal = Number(this.displayTotal) + Number(ans.answer)
              // })
              data['marks'] = res.data.finalMarks.finalMarks
              console.log("this.displayTotal", this.displayTotal)
              this.openDialog(QuizListModalComponent, data).subscribe(dialogRes => {
                console.log("modal closed", dialogRes)
                if (dialogRes == undefined) {
                  this.openSnackBar("Submission Successfull", "OK")
                  this.router.navigate(['/learner/view/' + this.learnerId], { queryParams: { job: this.jobId } })
                } else {
                  if (this.user && this.user.isLearner) {
                    this.hideSubmitBtn = true
                  }
                  this.openSnackBar("Submission Successfull", "OK")
                  console.log("this is for display new tab", this.stepper._steps.length);
                  if (this.stepper && this.stepper._steps.length == 4) {
                    this.selectedTabIndex = 3
                  } else {
                    this.selectedTabIndex = 2
                  }
                }
              })
            } else {
              this.openSnackBar("Submission Successfull", "OK")
              this.router.navigate(['/learner/view/' + this.learnerId], { queryParams: { job: this.jobId } })
            }
          }
        }, error => {
          console.log("ERROR WHILE UPDATE QUIZ", error)
          this.buttonLoaderSubmit = false
        })
      }

    }
    // })

  }

  submitLater() {

    // this._timeSheetService.getSystemDate().subscribe((date) => {
    // let systemDate = date.systemDate
    this.buttonLoaderSubmit = true;
    this.displayError = false
    console.log('THE ANSWER ARRAY IN SUBMIT LATER', this.answerArray);
    this.assessment.status = "Saved"
    this.assessment['createdDate'] = this.systemDate
    let assementArray = []
    assementArray.push(this.assessment)
    let obj = {
      details: this.detailsForm.value,
      assessmentList: assementArray,
      criteriaEvidence: this.criteriaEvidence,
      answers: this.answerArray,
      garbageSignatures: this.garbageSignatures,
      deletedImages: this.deletedImages,
      iqaSign: this.iqaSign,
      submitLater: true,
      quizId: this.quizId,
      learnerId: this.learnerId,
      jobId: this.jobId,
    }
    if (this.trainerSign) {
      obj['trainerSign'] = this.trainerSign;
    }
    if (this.learnerSign) {
      obj["learnerSign"] = this.learnerSign;
    }
    console.log("DATA TO SEND ON SERVER", obj)
    if (!this.isEdit) {
      this._quizService.addLearnerAns(obj).subscribe(res => {
        if (res) {
          this.buttonLoaderSubmit = false;
          this.openSnackBar("Answers Saved Successfully", "OK")
          this.router.navigate(['/learner/view/' + this.learnerId], { queryParams: { job: this.jobId } })
        }
      }, err => {
        this.buttonLoaderSubmit = false
      })
    } else {
      obj['submittedAnswerId'] = this.submittedAnswerId;
      // obj.assessment.status = 'Saved'
      // if (this.assessment.status == 'Pending') {
      //   obj.assessment.status = 'Submitted'
      // } else if (this.assessment.status == 'Request for Resubmission') {
      //   obj.assessment.status = 'Re-Submitted'
      // }
      console.log("<============================IN EDIT====================+++++++>");
      this._quizService.editLearnerAns(obj).subscribe(res => {
        if (res) {
          this.openSnackBar("Answers Saved Successfully", "OK")
          this.router.navigate(['/learner/view/' + this.learnerId], { queryParams: { job: this.jobId } })
        }
      }, error => {
        console.log("error", error);

        this.buttonLoaderSubmit = false
      })
    }
    // })
  }

  addFiles(singleQuestion) {
    let obj = {
      isAppearQuiz: true
    }
    this.openDialog(NewFileModalComponent, obj).subscribe(res => {
      console.log(res)
      console.log("SingleQuestion in fileres", singleQuestion)
      // singleQuestion.files = res
      res.forEach((singleImage) => {
        if (singleQuestion.answerId) {
          obj['answerId'] = singleQuestion.answerId
        }
        console.log("answer array =====>", this.answerArray);

        if (this.answerArray.length > 0) {
          let index = _.findIndex(this.answerArray, function (o) { return o.questionId == singleQuestion._id })
          if (index > -1) {
            this.answerArray[index].files.push(singleImage)
          }
          else {
            let obj = {
              questionId: singleQuestion._id,
              answer: "",
              quizId: this.quizId,
              learnerId: this.learnerId,
              files: [],
              deleteImage: []
            }
            obj.files.push(singleImage);
            this.answerArray.push(obj)
          }
        }
        else {
          let obj = {
            questionId: singleQuestion._id,
            answer: "",
            quizId: this.quizId,
            learnerId: this.learnerId,
            files: [],
            deleteImage: []
          }
          obj.files.push(singleImage)
          this.answerArray.push(obj)
        }
      })

      console.log('RES in FIle Upload', this.answerArray)
    })
  }
  removeImage(file, singleQuestion, imageFileIndex, ansIndex) {
    console.log(file)
    let data
    let obj = {
      isDelete: true,
      msg: 'Are you sure you want to remove this file?'
    }
    this.openDialog(DeleteConfirmModalComponent, obj).subscribe(confirm => {
      console.log("confirm data", confirm);
      if (confirm == undefined) return
      else if (confirm == 'yes') {

        let index = _.findIndex(this.answerArray, function (o) { return o.questionId == singleQuestion._id })
        console.log(index, imageFileIndex);
        if (index > -1) {
          if (file._id) {

            this.answerArray[index].deleteImage.push(file._id)
            this.deletedImages.push(file._id);
          }
          this.answerArray[index].files.splice(imageFileIndex, 1);
        }
        this.hide(ansIndex);
        console.log("this ==>", this.answerArray);
        console.log("this deted==>", this.deletedImages);
      }

    })
  }
  redirect(role) {
    console.log("ROLE +++++++++++++++>", role)
    // if(role == this.currentUser.userRole[0] || "iqa"){
    this.openDialog(SignaturePadComponent).subscribe(data => {
      if (data) {

        switch (role) {
          case "learner":
            if (this.learnerSign) {
              this.garbageSignatures.push(this.learnerSign);
            }
            this.learnerSign = data;
            this.learnerSignError = false;
            break;
          case "trainer":
            if (this.trainerSign) {
              this.garbageSignatures.push(this.trainerSign);

            }
            this.trainerSign = data;
            this.trainerSignError = false;
            // code...
            break;
          case "iqa":
            if (this.iqaSign) {
              this.garbageSignatures.push(this.iqaSign);
            }
            this.iqaSign = data;
            this.iqaSignError = false;
            // code...
            break;

          default:
            // code...
            break;
        }
        console.log("this.learnerSign =====> ", this.learnerSign);
        console.log("this.trainerSign =====> ", this.trainerSign);
        console.log("this.iqaSign =====> ", this.iqaSign);
        console.log("data from signature", data)
      }
    })
    /*}
    else{
      alert('Not authorized');
    }*/
  }
  getCriteriaEvidenceList(event) {
    // console.log("%cevent in appear quiz on evidence change", "color:blue", event);
    this.criteriaEvidence = event
  }

  // API

  getQuestions() {
    this._quizService.getQuestionsByQuizId(this.quizId).subscribe(response => {
      console.log("res in APPEAR quiz", response);
      let res = response.data.data
      this.systemDate = response.date


      if ((this.user.isLearner) && res.quizDetail.quizId == '604240853d8d3150dc5dfb7d') {
        this.disableQuiz = true
        this.hideSubmitBtn = true
        this.isNotDisplay = true
      }
      if ((this.user.isTrainer || this.user.isAdmin) && res.quizDetail.quizId == '604240853d8d3150dc5dfb7d') {
        this.disableQuiz = false
        this.hideSubmitBtn = false
        this.isNotDisplay = true
      }
      // let alphabates = String.fromCharCode(...Array(123).keys()).slice(97)
      // console.log("what is alphabates", alphabates);
      // this.alphabet = [...Array(26).keys()].map(i => String.fromCharCode(i + 97));
      console.log("what is this =======", this.alphabet);
      // let alphaArray = alphabates.split("");
      this.alphabet = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]
      // console.log("this is the final array to print", alphaArray);

      // this.loading = false
      if (res) {
        this.getAnswers()
        if (res.questions.length == 0) {
          this.noDataMsg = {
            title: "No Questions!",
            data: "You have not yet added any questions"
          }
        }
        else {
          this.questions = res.questions
          this.questions.forEach((item) => {
            if (item.questionType != "None") {
              this.totalQuestionsList.push(item)
            }
          })


          this.quizDetails = res.quizDetail
          this.isDate = res.quizDetail.isDate
          console.log("here is the is date value", res.quizDetail)
          if (this.quizDetails && this.quizDetails.quizName && this.quizDetails.quizName == 'Manual Handling Course Practical Assessment') {
            this.isTrainerQuiz = true
          }
          else {
            this.isTrainerQuiz = false;
          }
          console.log("this. is trainer quiz ======>", this.quizDetails.quizId)
          this.isUnit = res.quizDetail.isUnits

          this.questions.forEach((singleQuestion) => {

            let ansArr = []
            if (singleQuestion && singleQuestion.inputList) {


              for (let i = 0; i < singleQuestion.inputList.length; i++) {
                // console.log('singleAnswer.answer', singleAnswer.answer)

                let ansObj = {
                  answerSubmitted: '',
                  files: [],
                  ansIndex: '',
                  deleteImage: []
                }
                if (singleQuestion.question.title == "Name:") {
                  ansObj.answerSubmitted = this.currentUser.name
                }
                ansArr.push(ansObj)
                singleQuestion['answers'] = ansArr
              }
            } else {

              for (let i = 0; i < singleQuestion.inputNo; i++) {
                // console.log('singleAnswer.answer', singleAnswer.answer)

                let ansObj = {
                  answerSubmitted: '',
                  files: [],
                  ansIndex: '',
                  deleteImage: []
                }
                if (singleQuestion.question.title == "Name:") {
                  ansObj.answerSubmitted = this.currentUser.name
                }
                ansArr.push(ansObj)
                singleQuestion['answers'] = ansArr
              }
            }
          })


          console.log("this is the final array to display all questions", this.questions);

        }
      }
      else {
        this.noDataMsg = {
          title: "No Questions!",
          data: "You have not yet added any questions"
        }
      }
    })
  }

  getAnswers() {
    this.loading = true
    this._quizService.getLearnerAns(this.quizId, this.learnerId, this.jobId).subscribe(res => {
      console.log("getLearnerAns getLearnerAns", res);
      if (res.data.length > 0) {
        this.isEdit = true

        let lastAssesment = res.data[0].assessmentList.slice(-1)[0]
        console.log("what is last element data", lastAssesment);
        let assesmentList = res.data[0].assessmentList
        this.submittedAnswerId = res.data[0]._id
        if (lastAssesment != undefined) {
          this.assessment = lastAssesment;
        }
        this.iqaSign = res.data[0].iqaSign;
        this.learnerSign = res.data[0].learnerSign;
        this.trainerSign = res.data[0].trainerSign;
        // this.learnerStatus = this.assessment.status
        this.quizDetails = res.data[0].quizId
        this.questionsAnswer = res.data[0].answers
        this.unitsValue = res.data[0].units
        this.evidenceValue = res.data[0].evidenceId[0]
        this.date = res.data[0].date;
        console.log("this date was here ======>", this.date)
        if (lastAssesment != undefined) {
          this.assignStatus = lastAssesment.status
        }
        console.log("evidence value =======>", this.evidenceValue);
        this.detailsForm = this.formBuilder.group({
          date: new FormControl(this.date ? this.date : ""),
          evidence: new FormControl(this.evidenceValue),
          units: new FormControl(this.unitsValue ? this.unitsValue : "")
        });
        if (this.assessment && this.assessment.status != 'Pending' && !this.user.isLearner) {
          // this.assessment["trainerSign"] = this.trainerSign;
          // this.assessment["iqaSign"] = this.iqaSign;
          let obj = {
            assesmentList: assesmentList,
            trainerSign: this.trainerSign,
            iqaSign: this.iqaSign,
            lastStatus: this.assignStatus,
            role: this.userRole
          }
          // this.openFilesSideNav.emit({ assessment: obj })
          this._fileService.displayFile({ assessment: obj })
          this.loading = false
        }
        if (this.assessment && this.assessment.status == "Submitted" || this.assessment.status == "Completed") {
          if (this.user.isLearner && this.learnerSign != null) {
            this.hideSubmitBtn = true
            this.isTrainerQuiz = false
            // this.buttonLoaderSubmit = tr
          }
          if (this.user.isTrainer && this.learnerSign != null) {
            this.hideSubmitBtn = true
            this.isTrainerQuiz = false
          }
        }
      }
      console.log("tjos . questions ==========+>", this.questions);
      console.log("this.questionsAnswer ======>", this.questionsAnswer);
      console.log("res.data.length ======>", res.data.length);
      if (res.data.length > 0) {
        let ansArr = []
        console.log("in IF ====================>");
        this.questions.forEach((singleQuestion) => {
          ansArr = []
          let isQuestionAnswered: any = false;
          this.questionsAnswer.forEach((singleAnswer, answerIndex) => {
            // console.log("single answer details", singleAnswer);

            if (singleQuestion._id == (singleAnswer.questionId[0] && singleAnswer.questionId[0]._id)) {
              isQuestionAnswered = true;
              if (singleAnswer.questionId[0].questionType == "Dragable Cards") {
                singleAnswer.answer = JSON.parse(singleAnswer.answer);
              }
              let obj = {
                questionId: singleQuestion._id,
                answer: singleAnswer.answer,
                ansIndex: singleAnswer.ansIndex,
                answerId: singleAnswer._id,
                quizId: this.quizId,
                learnerId: this.learnerId,
                files: singleAnswer.files,
                deleteImage: []
              }
              // if(answerIndex)
              this.answerArray.push(obj)
              // console.log("@580 ===>", this.answerArray);
              console.log("value of single quwstion", singleQuestion);
              console.log("answers array details", ansArr);
              console.log("single answer details", singleAnswer);
              singleQuestion['selectedAns'] = singleAnswer.answer
              let obj1 = {
                questionId: singleQuestion._id
              }

              let questionIndex = _.findIndex(this.uniqQuestion, function (o) { return (o.questionId == singleQuestion._id) });
              console.log("==============,", questionIndex);
              if (questionIndex == -1) {
                this.uniqQuestion.push(obj1)
              }
              console.log("call this else part", ' ');

              for (let i = 0; i < singleQuestion.inputNo; i++) {
                // console.log('singleAnswer.answer', singleAnswer.answer)

                let ansObj = {
                  answerSubmitted: singleAnswer.answer,
                  files: singleAnswer.files,
                  answerId: singleAnswer._id,
                  ansIndex: singleAnswer.ansIndex,
                  deleteImage: []
                }
                console.log("second if condition", ansObj);

                let index = _.findIndex(ansArr, function (o) { return (o.answerId == singleAnswer._id && o.ansIndex == singleAnswer.ansIndex) })
                if (index > -1) {
                } else {
                  ansArr.push(ansObj)
                }
              }
              // }
            }
            this.cd.detectChanges()
          })
          // singleQuestion['answers'] = ansArr
          // console.log("final obj of all answers", ansArr);

          if (isQuestionAnswered == true) {
            console.log("what is the ans array length", ansArr);

            if (ansArr && ansArr.length == singleQuestion.inputNo) {
              singleQuestion['answers'] = ansArr
            } else {
              console.log("do something for other answers");
              let remaining = singleQuestion.inputNo - ansArr.length
              console.log("remaining ans data=======", remaining);
              for (let i = 0; i < remaining; i++) {
                let ansObj = {
                  answerSubmitted: '',
                  files: [],
                  answerId: null,
                  ansIndex: null,
                  deleteImage: []
                }
                ansArr.push(ansObj)
                // }
              }
              singleQuestion['answers'] = ansArr


            }
            for (let i = 0; i < singleQuestion['answers'].length; i++) {
              if (singleQuestion['answers'][i].ansIndex) {
                let b = singleQuestion['answers'][singleQuestion['answers'][i].ansIndex];
                singleQuestion['answers'][singleQuestion['answers'][i].ansIndex] = singleQuestion['answers'][i];
                singleQuestion['answers'][i] = b;
              }
            }
            // console.log("final single question details", singleQuestion);
          }
          else {
            for (let i = 0; i < singleQuestion.inputNo; i++) {
              let ansObj = {
                answerSubmitted: '',
                files: [],
                answerId: null,
                ansIndex: null,
                deleteImage: []
              }
              ansArr.push(ansObj)
            }
          }
          singleQuestion['answers'] = ansArr
        })
      }
      if (res && !res.data.length) {
        // this.disableQuiz = true
      }
      // else{
      // }
      this.loading = false;
      // console.log("tjos . questions ==========+>", this.answerArray);
    }, (err) => {

    })
  }


  getEvidenceList() {
    this._learnerService.getEvidenceByLearner(this.learnerId, this.jobId).subscribe(res => {
      console.log("RES", res);

      this.evidences = res
      // this.loading = false
      // this.updateData(this.allEvidenceses)
    })
  }


  // getRadioButtonValue(singleOption, singleQuestion) {
  //   console.log("this is single option value", singleQuestion, singleOption);

  //   if (singleQuestion && singleQuestion.selectedAns) {
  //     if (singleQuestion.selectedAns == singleOption) {
  //       return true
  //     } 
  //   }
  // }


}